// import { format, endOfQuarter } from 'date-fns';
import {
  categoryRange,
  range,
} from '../layer-builder';

export const censusTimelineLayers = ({ download = true } = {}) => ({
  header: 'Socioeconomics & Demographics',
  layers: [
    range({
      label: 'Population',
      key: 'population',
      source: 'census_history',
      timeline: {
        dateColumn: 'update_date',
        source: 'census_history',
        key: 'population',
        displayFirstQuarter: true,
        start: 'Jan 1 2012',
        end: 'Jan 1 2021',
      },
      colorScheme: 'positive-1',
      unit: 'number',
      download: !download ? null : {
        keys: ['name', 'population'],
      },
    }),
    range({
      label: 'Social Vulnerability',
      key: 'social_vulnerability',
      source: 'census_history',
      colorScheme: 'negative-2',
      filterString: 'is_latest=1',
      unit: 'number',
      download: !download ? null : {
        keys: ['name', 'social_vulnerability'],
      },
    }),

    range({
      label: 'Median Household Income',
      key: 'med_hh_inc',
      source: 'census_history',
      unit: 'dollars',
      colorScheme: 'positive-1',
      timeline: {
        dateColumn: 'update_date',
        source: 'census_history',
        key: 'med_hh_inc',
        displayFirstQuarter: true,
        start: 'Jan 1 2012',
        end: 'Jan 1 2021',
      },
      download: !download ? null : {
        keys: ['name', 'med_hh_inc'],
      },
    }),
    range({
      label: 'Broadband Internet Access',
      key: 'broadband',
      source: 'census_history',
      unit: 'decimal_percent',
      colorScheme: 'positive-2',
      timeline: {
        dateColumn: 'update_date',
        source: 'census_history',
        key: 'broadband',
        displayFirstQuarter: true,
        start: 'Jan 1 2012',
        end: 'Jan 1 2021',
      },
      download: !download ? null : {
        keys: ['name', 'broadband'],
      },
    }),
    range({
      label: 'Households with Computer Access',
      key: 'hh_w_comp',
      source: 'census_history',
      unit: 'decimal_percent',
      colorScheme: 'positive-3',
      timeline: {
        dateColumn: 'update_date',
        source: 'census_history',
        key: 'hh_w_comp',
        displayFirstQuarter: true,
        start: 'Jan 1 2012',
        end: 'Jan 1 2021',
      },
      download: !download ? null : {
        keys: ['name', 'hh_w_comp'],
      },
    }),
    range({
      label: 'Poverty Rate',
      key: 'pov_pct',
      source: 'census_history',
      unit: 'decimal_percent',
      colorScheme: 'negative-1',
      timeline: {
        dateColumn: 'update_date',
        source: 'census_history',
        key: 'pov_pct',
        displayFirstQuarter: true,
        start: 'Jan 1 2012',
        end: 'Jan 1 2021',
      },
      download: !download ? null : {
        keys: ['name', 'pov_pct'],
      },
    }),
    range({
      label: "Bachelor's Degree Holder Rate",
      key: 'ed_ba_plus',
      source: 'census_history',
      unit: 'decimal_percent',
      colorScheme: 'positive-1',
      timeline: {
        dateColumn: 'update_date',
        source: 'census_history',
        key: 'ed_ba_plus',
        displayFirstQuarter: true,
        start: 'Jan 1 2012',
        end: 'Jan 1 2021',
      },
      download: !download ? null : {
        keys: ['name', 'ed_ba_plus'],
      },
    }),

    range({
      label: 'Households with Children Under 18',
      key: 'hh_w_kids',
      source: 'census_history',
      unit: 'decimal_percent',
      colorScheme: 'positive-1',
      timeline: {
        dateColumn: 'update_date',
        source: 'census_history',
        key: 'hh_w_kids',
        displayFirstQuarter: true,
        start: 'Jan 1 2012',
        end: 'Jan 1 2021',
      },
      download: !download ? null : {
        keys: ['name', 'hh_w_kids'],
      },
    }),

    range({
      label: '% of Population Hispanic or Latino (of any race)',
      key: 'hispanic',
      source: 'census_history',
      colorScheme: 'positive-1',
      unit: 'decimal_percent',
      timeline: {
        dateColumn: 'update_date',
        source: 'census_history',
        key: 'hispanic',
        displayFirstQuarter: true,
        start: 'Jan 1 2012',
        end: 'Jan 1 2021',
      },
      download: !download ? null : {
        keys: ['name', 'hispanic'],
      },
    }),
    range({
      label: '% of Population White',
      key: 'rc_white',
      source: 'census_history',
      unit: 'decimal_percent',
      colorScheme: 'positive-2',
      timeline: {
        dateColumn: 'update_date',
        source: 'census_history',
        key: 'rc_white',
        displayFirstQuarter: true,
        start: 'Jan 1 2012',
        end: 'Jan 1 2021',
      },
      values: [0, 0.025, 0.05, 0.1, 0.2, 0.4],
      download: !download ? null : {
        keys: ['name', 'rc_white'],
      },
    }),
    range({
      label: '% of Population Black or African American',
      key: 'rc_afam',
      source: 'census_history',
      unit: 'decimal_percent',
      colorScheme: 'positive-2',
      timeline: {
        dateColumn: 'update_date',
        source: 'census_history',
        key: 'rc_afam',
        displayFirstQuarter: true,
        start: 'Jan 1 2012',
        end: 'Jan 1 2021',
      },
      values: [0, 0.025, 0.05, 0.1, 0.2, 0.4],
      download: !download ? null : {
        keys: ['name', 'rc_afam'],
      },
    }),
    range({
      label: '% of Population American Indian or Alaska Native',
      key: 'rc_natv',
      source: 'census_history',
      unit: 'decimal_percent',
      colorScheme: 'positive-2',
      timeline: {
        dateColumn: 'update_date',
        source: 'census_history',
        key: 'rc_natv',
        displayFirstQuarter: true,
        start: 'Jan 1 2012',
        end: 'Jan 1 2021',
      },
      values: [0, 0.025, 0.05, 0.1, 0.2, 0.4],
      download: !download ? null : {
        keys: ['name', 'rc_natv'],
      },
    }),
    range({
      label: '% of Population Asian',
      key: 'rc_asian',
      source: 'census_history',
      unit: 'decimal_percent',
      colorScheme: 'positive-2',
      timeline: {
        dateColumn: 'update_date',
        source: 'census_history',
        key: 'rc_asian',
        displayFirstQuarter: true,
        start: 'Jan 1 2012',
        end: 'Jan 1 2021',
      },
      values: [0, 0.025, 0.05, 0.1, 0.2, 0.4],
      download: !download ? null : {
        keys: ['name', 'rc_asian'],
      },
    }),
    range({
      label: '% of Population Native Hawaiian or Other Pacific Islander',
      key: 'rc_islnd',
      source: 'census_history',
      unit: 'decimal_percent',
      colorScheme: 'positive-2',
      timeline: {
        dateColumn: 'update_date',
        source: 'census_history',
        key: 'rc_islnd',
        displayFirstQuarter: true,
        start: 'Jan 1 2012',
        end: 'Jan 1 2021',
      },
      values: [0, 0.025, 0.05, 0.1, 0.2, 0.4],
      download: !download ? null : {
        keys: ['name', 'rc_islnd'],
      },
    }),
    range({
      label: '% of Population Other Race',
      key: 'rc_other',
      source: 'census_history',
      unit: 'decimal_percent',
      colorScheme: 'positive-2',
      timeline: {
        dateColumn: 'update_date',
        source: 'census_history',
        key: 'rc_other',
        displayFirstQuarter: true,
        start: 'Jan 1 2012',
        end: 'Jan 1 2021',
      },
      values: [0, 0.025, 0.05, 0.1, 0.2, 0.4],
      download: !download ? null : {
        keys: ['name', 'rc_other'],
      },
    }),
    range({
      label: '% of Population Two or More Races',
      key: 'rc_2p',
      source: 'census_history',
      unit: 'decimal_percent',
      colorScheme: 'positive-2',
      timeline: {
        dateColumn: 'update_date',
        source: 'census_history',
        key: 'rc_2p',
        displayFirstQuarter: true,
        start: 'Jan 1 2012',
        end: 'Jan 1 2021',
      },
      values: [0, 0.025, 0.05, 0.1, 0.2, 0.4],
      download: !download ? null : {
        keys: ['name', 'rc_2p'],
      },
    }),
  ],
});

export const layers = [
  {
    header: 'Housing & Real Estate',
    layers: [
      categoryRange({
        colorScheme: 'positive-3',
        label: 'Housing Market Strength',
        key: 'submarket',
        source: 'census_history',
        filterString: 'is_latest=1',
        values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        unit: 'text_map',
        map: {
          1: '1 Weak',
          10: '10 Strong',
        },
        download: {
          keys: ['name', 'submarket'],
        },
      }),
      range({
        colorScheme: 'positive-3',
        label: 'Median Home Value',
        key: 'med_hom_val',
        source: 'census_history',
        timeline: {
          dateColumn: 'update_date',
          source: 'census_history',
          key: 'med_hom_val',
          displayFirstQuarter: true,
          start: 'Jan 1 2012',
          end: 'Jan 1 2021',
        },
        unit: 'dollars',
        download: {
          keys: ['name', 'med_hom_val'],
        },
      }),
      range({
        label: 'Housing Affordability',
        key: 'housing_affordability',
        source: 'census_history',
        filterString: 'is_latest=1',
        colorScheme: 'negative-2',
        unit: 'number',
        download: {
          keys: ['name', 'housing_affordability'],
        },
      }),
      range({
        label: 'Housing Affordability - Renters',
        key: 'housing_affordability_renters',
        source: 'census_history',
        filterString: 'is_latest=1',
        colorScheme: 'negative-2',
        unit: 'number',
        download: {
          keys: ['name', 'housing_affordability_renters'],
        },
      }),
      range({
        label: 'Housing Affordability - Owners',
        key: 'housing_affordability_owners',
        source: 'census_history',
        filterString: 'is_latest=1',
        colorScheme: 'negative-2',
        unit: 'number',
        download: {
          keys: ['name', 'housing_affordability_owners'],
        },
      }),
      range({
        label: 'Median Rent',
        key: 'med_rent',
        source: 'census_history',
        unit: 'dollars',
        colorScheme: 'positive-1',
        timeline: {
          dateColumn: 'update_date',
          source: 'census_history',
          key: 'med_rent',
          displayFirstQuarter: true,
          start: 'Jan 1 2012',
          end: 'Jan 1 2021',
        },
        download: {
          keys: ['name', 'med_rent'],
        },
      }),

      range({
        label: 'Vacancy Rate',
        key: 'hu_unocc',
        unit: 'decimal_percent',
        colorScheme: 'positive-3',
        timeline: {
          dateColumn: 'update_date',
          source: 'census_history',
          key: 'hu_unocc',
          displayFirstQuarter: true,
          start: 'Jan 1 2012',
          end: 'Jan 1 2021',
        },
        download: {
          keys: ['name', 'hu_unocc'],
        },
      }),
      range({
        label: 'Owner Occupancy Rate',
        key: 'hu_own_occ',
        unit: 'decimal_percent',
        colorScheme: 'positive-3',
        timeline: {
          dateColumn: 'update_date',
          source: 'census_history',
          key: 'hu_own_occ',
          displayFirstQuarter: true,
          start: 'Jan 1 2012',
          end: 'Jan 1 2021',
        },
        download: {
          keys: ['name', 'hu_own_occ'],
        },
      }),
    ],
  },
  { ...censusTimelineLayers() },
  {
    header: 'Education',
    layers: [
      range({
        label: 'High school graduate (includes equivalency)',
        key: 'ed_hs_plus',
        source: 'census_history',
        colorScheme: 'positive-1',
        unit: 'decimal_percent',
        timeline: {
          dateColumn: 'update_date',
          source: 'census_history',
          key: 'ed_hs_plus',
          displayFirstQuarter: true,
          start: 'Jan 1 2012',
          end: 'Jan 1 2021',
        },
        download: {
          keys: ['name', 'ed_hs_plus'],
        },
      }),
      range({
        label: 'Associate\'s degree',
        key: 'ed_assoc_plus',
        source: 'census_history',
        colorScheme: 'positive-3',
        unit: 'decimal_percent',
        timeline: {
          dateColumn: 'update_date',
          source: 'census_history',
          key: 'ed_assoc_plus',
          displayFirstQuarter: true,
          start: 'Jan 1 2012',
          end: 'Jan 1 2021',
        },
        download: {
          keys: ['name', 'ed_assoc_plus'],
        },
      }),
      range({
        label: 'Bachelor\'s degree',
        key: 'ed_ba_plus',
        source: 'census_history',
        colorScheme: 'positive-1',
        unit: 'decimal_percent',
        timeline: {
          dateColumn: 'update_date',
          source: 'census_history',
          key: 'ed_ba_plus',
          displayFirstQuarter: true,
          start: 'Jan 1 2012',
          end: 'Jan 1 2021',
        },
        download: {
          keys: ['name', 'ed_ba_plus'],
        },
      }),
      range({
        label: 'Graduate or professional degree',
        key: 'ed_doc_plus',
        source: 'census_history',
        colorScheme: 'positive-2',
        unit: 'decimal_percent',
        timeline: {
          dateColumn: 'update_date',
          source: 'census_history',
          key: 'ed_doc_plus',
          displayFirstQuarter: true,
          start: 'Jan 1 2012',
          end: 'Jan 1 2021',
        },
        download: {
          keys: ['name', 'ed_doc_plus'],
        },
      }),
      range({
        label: 'Nursery school, preschool (%)',
        key: 'enroll_preschool_pct',
        source: 'census_history',
        colorScheme: 'positive-1',
        unit: 'decimal_percent',
        timeline: {
          dateColumn: 'update_date',
          source: 'census_history',
          key: 'enroll_preschool_pct',
          displayFirstQuarter: true,
          start: 'Jan 1 2012',
          end: 'Jan 1 2021',
        },
        download: {
          keys: ['name', 'enroll_preschool_pct'],
        },
      }),
      range({
        label: 'Nursery school, preschool (count)',
        key: 'enroll_preschool',
        source: 'census_history',
        colorScheme: 'positive-2',
        unit: 'number',
        timeline: {
          dateColumn: 'update_date',
          source: 'census_history',
          key: 'enroll_preschool',
          displayFirstQuarter: true,
          start: 'Jan 1 2012',
          end: 'Jan 1 2021',
        },
        download: {
          keys: ['name', 'enroll_preschool'],
        },
      }),
    ],
  },
  {
    header: 'Economic',
    layers: [
      range({
        label: 'Employed',
        key: 'emp_pct',
        source: 'census_history',
        colorScheme: 'positive-1',
        unit: 'decimal_percent',
        timeline: {
          dateColumn: 'update_date',
          source: 'census_history',
          key: 'emp_pct',
          displayFirstQuarter: true,
          start: 'Jan 1 2012',
          end: 'Jan 1 2021',
        },
        download: {
          keys: ['name', 'emp_pct'],
        },
      }),
      range({
        label: 'Unemployed',
        key: 'unemp_pct',
        source: 'census_history',
        colorScheme: 'positive-1',
        unit: 'decimal_percent',
        timeline: {
          dateColumn: 'update_date',
          source: 'census_history',
          key: 'unemp_pct',
          displayFirstQuarter: true,
          start: 'Jan 1 2012',
          end: 'Jan 1 2021',
        },
        download: {
          keys: ['name', 'unemp_pct'],
        },
      }),
      range({
        label: 'Agriculture, forestry, fishing and hunting, and mining',
        key: 'ind_agff',
        source: 'census_history',
        colorScheme: 'positive-1',
        unit: 'decimal_percent',
        timeline: {
          dateColumn: 'update_date',
          source: 'census_history',
          key: 'ind_agff',
          displayFirstQuarter: true,
          start: 'Jan 1 2012',
          end: 'Jan 1 2021',
        },
        download: {
          keys: ['name', 'ind_agff'],
        },
      }),
      range({
        label: 'Construction',
        key: 'ind_construction',
        source: 'census_history',
        colorScheme: 'positive-1',
        unit: 'decimal_percent',
        timeline: {
          dateColumn: 'update_date',
          source: 'census_history',
          key: 'ind_construction',
          displayFirstQuarter: true,
          start: 'Jan 1 2012',
          end: 'Jan 1 2021',
        },
        download: {
          keys: ['name', 'ind_construction'],
        },
      }),
      range({
        label: 'Manufacturing',
        key: 'ind_manufacture',
        source: 'census_history',
        colorScheme: 'positive-1',
        unit: 'decimal_percent',
        timeline: {
          dateColumn: 'update_date',
          source: 'census_history',
          key: 'ind_manufacture',
          displayFirstQuarter: true,
          start: 'Jan 1 2012',
          end: 'Jan 1 2021',
        },
        download: {
          keys: ['name', 'ind_manufacture'],
        },
      }),
      range({
        label: 'Wholesale trade',
        key: 'ind_wholesale',
        source: 'census_history',
        colorScheme: 'positive-1',
        unit: 'decimal_percent',
        timeline: {
          dateColumn: 'update_date',
          source: 'census_history',
          key: 'ind_wholesale',
          displayFirstQuarter: true,
          start: 'Jan 1 2012',
          end: 'Jan 1 2021',
        },
        download: {
          keys: ['name', 'ind_wholesale'],
        },
      }),
      range({
        label: 'Retail trade',
        key: 'ind_retail',
        source: 'census_history',
        colorScheme: 'positive-1',
        unit: 'decimal_percent',
        timeline: {
          dateColumn: 'update_date',
          source: 'census_history',
          key: 'ind_retail',
          displayFirstQuarter: true,
          start: 'Jan 1 2012',
          end: 'Jan 1 2021',
        },
        download: {
          keys: ['name', 'ind_retail'],
        },
      }),
      range({
        label: 'Transportation and warehousing, and utilities',
        key: 'ind_trans',
        source: 'census_history',
        colorScheme: 'positive-1',
        unit: 'decimal_percent',
        timeline: {
          dateColumn: 'update_date',
          source: 'census_history',
          key: 'ind_trans',
          displayFirstQuarter: true,
          start: 'Jan 1 2012',
          end: 'Jan 1 2021',
        },
        download: {
          keys: ['name', 'ind_trans'],
        },
      }),
      range({
        label: 'Information',
        key: 'ind_info',
        source: 'census_history',
        colorScheme: 'positive-1',
        unit: 'decimal_percent',
        timeline: {
          dateColumn: 'update_date',
          source: 'census_history',
          key: 'ind_info',
          displayFirstQuarter: true,
          start: 'Jan 1 2012',
          end: 'Jan 1 2021',
        },
        download: {
          keys: ['name', 'ind_info'],
        },
      }),
      range({
        label: 'Finance and insurance, and real estate and rental and leasing',
        key: 'ind_finance',
        source: 'census_history',
        colorScheme: 'positive-1',
        unit: 'decimal_percent',
        timeline: {
          dateColumn: 'update_date',
          source: 'census_history',
          key: 'ind_finance',
          displayFirstQuarter: true,
          start: 'Jan 1 2012',
          end: 'Jan 1 2021',
        },
        download: {
          keys: ['name', 'ind_finance'],
        },
      }),
      range({
        label: 'Professional, scientific, and management, and administrative and ',
        key: 'ind_pro_science',
        source: 'census_history',
        colorScheme: 'positive-1',
        unit: 'decimal_percent',
        timeline: {
          dateColumn: 'update_date',
          source: 'census_history',
          key: 'ind_pro_science',
          displayFirstQuarter: true,
          start: 'Jan 1 2012',
          end: 'Jan 1 2021',
        },
        download: {
          keys: ['name', 'ind_pro_science'],
        },
      }),
      range({
        label: 'Educational services, and health care and social assistance',
        key: 'ind_ed',
        source: 'census_history',
        colorScheme: 'positive-1',
        unit: 'decimal_percent',
        timeline: {
          dateColumn: 'update_date',
          source: 'census_history',
          key: 'ind_ed',
          displayFirstQuarter: true,
          start: 'Jan 1 2012',
          end: 'Jan 1 2021',
        },
        download: {
          keys: ['name', 'ind_ed'],
        },
      }),
      range({
        label: 'Arts, entertainment, and recreation, and accommodation and food services',
        key: 'ind_art',
        source: 'census_history',
        colorScheme: 'positive-1',
        unit: 'decimal_percent',
        timeline: {
          dateColumn: 'update_date',
          source: 'census_history',
          key: 'ind_art',
          displayFirstQuarter: true,
          start: 'Jan 1 2012',
          end: 'Jan 1 2021',
        },
        download: {
          keys: ['name', 'ind_art'],
        },
      }),
      range({
        label: 'Other services, except public administration',
        key: 'ind_other',
        source: 'census_history',
        colorScheme: 'positive-1',
        unit: 'decimal_percent',
        timeline: {
          dateColumn: 'update_date',
          source: 'census_history',
          key: 'ind_other',
          displayFirstQuarter: true,
          start: 'Jan 1 2012',
          end: 'Jan 1 2021',
        },
        download: {
          keys: ['name', 'ind_other'],
        },
      }),
      range({
        label: 'Public administration',
        key: 'ind_public',
        source: 'census_history',
        colorScheme: 'positive-1',
        unit: 'decimal_percent',
        timeline: {
          dateColumn: 'update_date',
          source: 'census_history',
          key: 'ind_public',
          displayFirstQuarter: true,
          start: 'Jan 1 2012',
          end: 'Jan 1 2021',
        },
        download: {
          keys: ['name', 'ind_public'],
        },
      }),
    ],
  },
  {
    header: 'Neighborhood Revitalization',
    layers: [
      range({
        label: 'Predicted Rehabilitation Impact',
        key: 'rehab_impact_pred',
        source: 'census_history',
        filterString: 'is_latest=1',
        unit: 'dollars',
        colorScheme: 'positive-2',
        download: {
          keys: ['name', 'rehab_impact_pred'],
        },
      }),
      range({
        label: 'Predicted Demolition Impact',
        key: 'demo_impact_pred',
        source: 'census_history',
        filterString: 'is_latest=1',
        unit: 'dollars',
        colorScheme: 'positive-1',
        download: {
          keys: ['name', 'demo_impact_pred'],
        },
      }),
      range({
        label: 'Predicted # of Homes Impacted',
        key: 'homes_impacted',
        source: 'census_history',
        filterString: 'is_latest=1',
        colorScheme: 'positive-1',
        download: {
          keys: ['name', 'homes_impacted'],
        },
      }),
    ],
  },
  {
    header: 'Overlays',
    id: 'boundary-layers',
    layers: [
      {
        label: 'Road Labels',
        key: 'road_label_layer',
        url:
          'https://stamen-tiles-a.a.ssl.fastly.net/toner-labels/{z}/{x}/{y}@2x.png',
        style: {
          type: 'raster',
        },
      },
      {
        label: 'Roads',
        key: 'road_layer',
        url:
          'https://stamen-tiles.a.ssl.fastly.net/toner-lines/{z}/{x}/{y}@2x.png',
        style: {
          type: 'raster',
        },
      },
      {
        label: 'Census Block Group Borders',
        key: 'fips',
        source: 'census_history',
        filterString: 'is_latest=1',
        default: false,
        style: {
          type: 'line',
          paint: {
            'line-color': '#4b4c4d',
            'line-width': 1,
          },
        },
      },
      {
        label: 'City Borders',
        key: 'fips+city',
        source: 'census_history',
        filterString: 'is_latest=1&sumlevel=60&sumlevel=160',
        default: false,
        style: {
          type: 'line',
          paint: {
            'line-color': '#4b4c4d',
            'line-width': 1,
          },
        },
      },
      {
        label: 'County Borders',
        key: 'fips+county',
        source: 'census_history',
        filterString: 'is_latest=1&sumlevel=50',
        default: false,
        style: {
          type: 'line',
          paint: {
            'line-color': '#4b4c4d',
            'line-width': 1,
          },
        },
      },
    ],
  },
];
